// actions.ts
import { Context, IActions, ISaveMigrationImportPayload } from './actions.types'
import { RootState } from '@/store/types'
import { IMigrationImport, Notification, INotification } from '@/entities'
import { Utilities as appUtils } from '@/shared/utilities'
import { ActionTree } from 'vuex';

export const actions: IActions = {

    updateMigrationData(context: Context, payload: any) {
        let changededData={}
        var payloadData: ISaveMigrationImportPayload = {
            MigrationImportId: payload.MigrationImportId,
            ProgramId: payload.ProgramId,
            InitiativeCallId: payload.InitiativeCallId,
            GrantCode: payload.GrantCode,
            GrantStatusId: payload.GrantStatusId,
            ProgramOfficerId: payload.ProgramOfficerId,
            ImportData: payload.ImportData,
            ImportStatus: payload.ImportStatus
          };
        let transformedData=this.$services.migration.transformData(payloadData.ImportData);
        let stringData=JSON.stringify(transformedData);
        payloadData.ImportData = stringData;
        this.$services.migration.update(payloadData).then(data => {
            if (data) {
                //let transformedData = this.$services.migration.transformDBEntity(data.MigrationImport.ImportData, context.getters.rootTemplate, false, context.getters.indicators );
                    //changededData['importData']=transformedData
                    //changededData['otherInfo']=data
                //context.commit("setMigrationData", changededData)
                context.commit('application/setNotification', new Notification({ snack: true, text: 'Updated successfully', color: 'success' } as INotification), { root: true });
            }
        })
    },

    getMigrationData(context: Context, id: number) {
        let changededData={}
        return this.$services.migration.getDetail(id).then(data => {
            let transformedData = this.$services.migration.transformDBEntity(data.MigrationImport.ImportData, data.Schema, false, data.Indicators );
            changededData['importData']=transformedData
            changededData['otherInfo']=data
            context.commit("setMigrationData", changededData)
        })
    },

    saveMigrationData(context: Context, payload: any): any {
        let changededData={}
        context.commit('application/updateOverlay', true, { root: true });
        var payloadData: ISaveMigrationImportPayload = {
            MigrationImportId: payload.MigrationImportId,
            ProgramId: payload.ProgramId,
            InitiativeCallId: payload.InitiativeCallId,
            GrantCode: payload.GrantCode,
            GrantStatusId: payload.GrantStatusId,
            ProgramOfficerId: payload.ProgramOfficerId,
            ImportData: payload.ImportData,
            ImportStatus: payload.ImportStatus
          };
        var datum = appUtils.clone(payloadData);
        let transformedData=this.$services.migration.transformData(datum.ImportData);
        let stringData=JSON.stringify(transformedData);
        datum.ImportData = stringData;
        return this.$services.migration.update(datum)
            .then((data: any) => {
                if(data) {
                    //let transformedData = this.$services.migration.transformDBEntity(data.Record.ImportData, context.getters.rootTemplate, false, context.getters.indicators );
                    //changededData['importData']=transformedData
                    //changededData['otherInfo']=data
                    //context.commit('setMigrationData', changededData);
                    //context.commit('setMigrationImportData', changededData);
                    context.commit('application/updateOverlay', false, { root: true });
                    context.commit('application/setNotification', new Notification({ snack: true, text: 'Saved Successfully', color: 'success' } as INotification),  { root: true });
                    return true;
                } else {
                    context.commit('application/updateOverlay',  false , { root: true });
                    context.commit('application/setNotification', new Notification({ snack: true, isHtml: false, text: data.Message, color: 'error' } as INotification) , { root: true });
                    return false;
                }  
            })
            .catch((e) => {
                context.commit('application/updateOverlay',  false, { root: true } );
                context.commit('application/setNotification', new Notification({ snack: true, isHtml: false, text: e, color: 'error' } as INotification ), { root: true });
                return false;
            });
    },
    createCustomIndicatorForImport(context: Context, payload: any)
    {
        return this.$services.application.createCustomIndicatorForImport(payload.data)
        .then((data: any) => {
            if(data.Result === 'OK') {
                context.commit('addIndicator', data.Record);
            } else {
                let spliter = "</br>",
                errors = "",
                messages = data.Message.split(spliter);
            
                for (var i = 0; i < messages.length; i++) {
                    var message = messages[i].split("@#");
                    if (message && message[1]) {
                    errors += (i + 1).toString() + ". " + message[1] + spliter;
                }
            }
                context.commit('setNotification', new Notification({ snack: true, isHtml: true, text: errors, color: 'error' } as INotification))
            }

            return data;
        });        

    },
    updateCustomIndicatorForImport(context: Context, payload: any): void { 

        return this.$services.application.updateCustomIndicatorForImport(payload.data)
        .then((data: any) => {
            if(data.Result === 'OK') {
                context.commit('updateIndicator', data.Record);                
                return data.Record;
            } else {
                context.commit('setNotification', new Notification({ snack: true, isHtml: false, text: data.Message, color: 'error' } as INotification))
            }
        });        
    },
}